import Select from '../../../components/select.vue'
import {api, getHallCode} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';

export default {
  name: 'searchebook',
  data() {
    return {
      categoryId: {'desc': '全部', categoryId: ''},
      subCategoryId: {'desc': '全部', categoryId: ''},
      isbn: "",
      name: "",
      author: "",
      publisher: "",
      publishDate: "",
      bookCategorys: [],
      suBookCategorys: [],
      libCode: "",
      hallCode: "", //图书馆网站
      fromSearch: 0,//0表示首页高级搜索。1就是具体的高级搜索页面
    }
  },
  components: {
    Select,
  },
  watch: {
    categoryId(newValue, oldValue) {
      this.suBookCategorys = newValue.subList;
      this.subCategoryId = this.suBookCategorys[0];
    }
  },
  computed: {
    categoryDesc() {
      if (this.categoryId.desc == '全部') {
        return '全部'
      } else {
        return `${this.categoryId.desc}"` + '，' + `"${this.subCategoryId.desc}`
      }
    }
  },
  beforeMount() {
    this.fromSearch = this.$route.query.fromSearch;
    this.libCode = this.$route.query.libCode || '';
    this.hallCode = this.$route.query.hallCode || '';
    /*图书分类*/
    ajaxUtil.ajaxJson(api.ebook.category, null, "get", (data) => {
      this.bookCategorys = data.map(function (item, index, c) {
        item.desc = item.categoryName
        if (item.subList) {
          item.subList.map((subItem, indx) => {
            subItem.desc = subItem.categoryName;
            return subItem
          })
          item.subList.unshift({'desc': '全部', categoryId: item.categoryId});
        }
        return item
      });
      this.bookCategorys.unshift({'desc': '全部', categoryId: '', subList: [{desc: '全部', categoryId: ''}]});
      this.suBookCategorys = this.bookCategorys[0].subList
    }, null, this);
  },
  methods: {
    search() {
        var subCategoryId=this.subCategoryId.desc;
        if(subCategoryId!="全部"){
            subCategoryId=this.subCategoryId.categoryId;
        }else{
            subCategoryId="";
        }
      var pathStr = "/indexsearch";
      this.$router.push({
        path: pathStr,
        query: {
          oneLevelCategoryId: this.categoryId.categoryId,
          twoLevelCategoryId:subCategoryId ,
          categoryDesc: this.categoryDesc,
          isbn: this.isbn,
          name: this.name,
          author: this.author,
          publisher: this.publisher,
          publishDate: this.publishDate,
          type: 2,
          fromSearch: this.fromSearch,
          libCode: this.libCode,
          hallCode: this.hallCode
        }
      });
    },
  },

}
